import Swal from "sweetalert2";
import axios from "axios";
import { getAuthCredentials } from "../../../utils/auth";

const deleteNotification = async (notifId, notifName, onSuccess = () => {}) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: `This will permanently delete "${notifName}".`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#aaa",
    confirmButtonText: "Yes, delete it!",
    allowOutsideClick: false,
    allowEscapeKey: false,
    preConfirm: async () => {
      Swal.showLoading(); // shows circular spinner
      try {
        const { token } = await getAuthCredentials();
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/v1/api/notification/${notifId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return true;
      } catch (err) {
        Swal.hideLoading();
        Swal.showValidationMessage(
          err?.response?.data?.message || "Failed to delete notification."
        );
        return false;
      }
    },
  });

  if (result.isConfirmed) {
    await Swal.fire("Deleted!", "Notification has been deleted.", "success");
    onSuccess();
  }
};

export default deleteNotification;
